module.exports = __webpack_public_path__ + "fc20bae14c6d3ee46d7c9943e0376c0e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/styles/img/Placeholder user.svg
// module id = 390
// module chunks = 0